<!--
 * @Date: 2020-05-27 17:42:54
 * @LastEditors: Travin
 * @LastEditTime: 2020-06-26 18:23:32
--> 

<template>
	<div>
		<div>
			<span class="xbed-sub-title">门店经营利润表</span>
		</div>

		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>报表</BreadcrumbItem>
				<BreadcrumbItem>门店经营利润表</BreadcrumbItem>
			</Breadcrumb>
		</div>
		
		<br>
		<Form inline @submit.native.prevent="preventSubmit">
			<FormItem label="月份:" :label-width="110">
				<DatePicker type="month" placeholder="请选择" style="width: 150px" :clearable="false" v-model="queryParams.month"></DatePicker>
			</FormItem>
			<!-- <FormItem label="门店:" :label-width="84">
				<Input v-model="queryParams.chainId" style="width: 150px" placeholder="门店id / 门店名称"></Input>
			</FormItem> -->
			<FormItem label="门店：" prop="orderListForm.chainName" :label-width="80">
					<Select v-model="queryParams.chainId" ref="chainName" clearable filterable>
						<Option v-for="hotel in hotels" :key="hotel.sourceId" :value="hotel.sourceId">{{hotel.sourceName}}</Option>
					</Select>
			</FormItem>
            <FormItem label="状态:" prop="subjectOne" :label-width="90">
                <Cascader :data="subjectData" change-on-select style="width:120px;" @on-change="handleSubject"></Cascader>
            </FormItem>
            <br>
            <FormItem>
				<Button type="primary" @click="keyWordsTable">查询</Button>
			</FormItem>
		</Form>
		<Content>
			<Table class="expand-table" :columns="table.columns" :data="table.data" :loading="table.loading"></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement="top" :current="queryParams.pageNum" :total="table.total" :page-size="queryParams.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
			</div>
		</Content>
		<p style="text-align:center;font-size:14px">
    </p>
	</div>
</template>


<script>
import Utils from "../../../utils";
import API from "../../../api";
import Config from "@/config";
import Moment from "moment";
import expandRow from "@/components/table-inventory";

export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
        this.env = Utils.findFromLocalStorage( "env", "dev" );
        this.apiHeaders = {
            'x-ca-stage': Utils.aliHeaderEnv(this.env), //走阿里云需要
            'Authorization': Utils.findFromLocalStorage("Author-token"), //走阿里云需要
            'isForm': true //测试
        }
	},
	async mounted() {
		this.chainProfitMonthList();
		this.$Notice.config( {
			top: 200
		} )
		let selectListResp = ( await API.omsAPI[this.env].php.querySelectList() ).data;
		this.allHotels = selectListResp.data.chain;

		
	},
	components: {expandRow},
	data() {
		return {
            subjectData:[
                {
                value:null,
                label:'全部'
                },
                {
                value:0,
                label:'未审核'
                },
                {
                value:1,
                label:'已审核'
                }
			],
			allHotels: [],
			orderListForm: {
				sourceId: "",
			},
            exportBtn: false,
			queryParams: {
				pageNum: 1,
				pageSize: 20,
				month: '',
				chainId: '',
				state: ''
			},
			table: {
				data: [],
				total: 0,
				loading: false,
				columns: [
					{
						title: "月份",
						align: "center",
						width: 100,
						key: "month"
					},
					{
						title: "状态",
						align: "center",
						width: 80,
                        key: "state",
                        render: (h, params) => {
                            let status = params.row.state == 0 ? "未审核" : "已审核";
                            return h("div", { }, status);
                        }
					},
					{
						title: "门店",
						align: "center",
                        width: 170,
                        key: "chainName"
					},
					{
						title: "房间数",
						align: "center",
                        width: 80,
                        key: "onlineRoomNumber"
					},
					{
						title: "出租房晚",
						align: "center",
                        width: 95,
                        key: "leaseRoomNumber"
					},
					{
						title: "出租率(%)",
						align: "center",
                        width: 110,
                        key: "monthRentRate"
					},
					{
						title: "经营收入合计",
						align: "center",
                        width: 120,
                        key: "income"
					},
					{
						title: "经营成本合计",
						align: "center",
                        width: 120,
                        key: "cost"
					},
					{
						title: "本月经营利润",
						align: "center",
                        width: 120,
                        key: "profit"
                    },
                    {
						title: "操作",
						align: "center",
						width: 120,
						render: ( h, p ) => {
							return h(
								"Button",
								{
									props: {
										type: "primary",
										size: "small"
									},
									on: {
										click: () => {
											// if ( !Utils.hasPermission( 'oms_xbclean_MmRoomGoodsInventoryParticular_list' ) ) {
											// 	this.$Notice.error( {
											// 		title: "无权限操作"
											// 	} );
											// 	return
											// }
											if ( this.$router ) {
												window.open( `#/app/report/chainReportDetail?chainID=${ p.row.id }` )
											} else {
												window.open( `#/Report/Report/chainReportDetail?chainID=${ p.row.id }` );
											}
										}
									}
								},
								"查看详情"
							);
						}
					},
					{
						title: "导出",
						align: "center",
						width: 120,
						loading: "exportBtn",
						render: ( h, p ) => {
							return h(
								"Button",
								{
									props: {
										type: "primary",
										size: "small"
									},
									on: {
										click: () => {
											this.exportTable(p.row.id)
										}
									}
								},
								"导出明细"
							);
						}
					},
				]
			}
		};
	},
	computed: {
		hotels: function () {
			if ( !this.orderListForm.city && !this.orderListForm.hotspotName ) {
				return this.allHotels;
			}
		}
	},
	methods: {
        // 更改页码
		changePage( page ) {
			this.queryParams.pageNum = page;
			this.chainProfitMonthList()
        },
        // 更改size
		changePageSize( pageSize ) {
			this.queryParams.pageNum = 1;
			this.queryParams.pageSize = pageSize;
			this.chainProfitMonthList()
        },
        handleSubject(value, selectedData) {
            this.queryParams.state = selectedData[0].value
        },
		// 查询
		keyWordsTable() {
			this.chainProfitMonthList();
		},
		// 加载门店经营利润表 getChainProfitMonthList
		async chainProfitMonthList() {
			this.queryParams.month = this.queryParams.month ? Moment( this.queryParams.month ).format( "YYYY-MM" ) : "";
            let resp = ( await API.omsAPI[this.env].accountServer.getChainProfitMonthList(this.queryParams, this.apiHeaders));
            
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取列表失败",
					desc: resp.msg
				} );
				return;
            }
            console.log(resp.data.list)
			this.table.data = resp.data.list || [];
			this.table.total = resp.data.total;
		},
		exportTable(rowID){
            let exportUrl = Config[this.env].clientServerUrl.accountAli + "profitMonth/export/" + rowID
            Utils.exportAliExcelWeighting( exportUrl, '经营利润表明细', this.apiHeaders, this.$Notice.error, this, "exportBtn")
        },
		// // 导出表格
		// exportExcal() {
		// 	if ( !Utils.hasPermission( 'excel_MmRoomGoodsInventoryParticular' ) ) {
		// 		this.$Notice.error( {
		// 			title: "无权限操作"
		// 		} );
		// 		return
		// 	}
		// 	let params = {
		// 		roomId: this.queryParams.roomId,
		// 		roomName: this.queryParams.roomName,
		// 		month: this.queryParams.month,
		// 		goodsName: this.queryParams.goodsName,
		// 		stockNumber: this.queryParams.stockNumber,
		// 		associatedCityName: this.queryParams.associatedCityName,
		// 		page: 1,
		// 		size: 99999,
		// 	};
		// 	const initParam = params => {
		// 		let paramStr = "";
		// 		Object.keys( params ).forEach( item => {
		// 			if ( params[item] !== "" ) {
		// 				paramStr += item + "=" + params[item] + "&";
		// 			}
		// 		} );
		// 		return paramStr.substring( 0, paramStr.lastIndexOf( "&" ) );
		// 	};
		// 	let paramStr = initParam( params );
		// 	let url = `${
		// 		Config[this.env].analysisUrl
		// 		}excel/MmMonthlyRoomGoodsInventories?${ paramStr }`;
		// 	// window.open(url, "_blank");
		// 	Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )

		// },
		// preventSubmit() {
		// 	return false;
		// }
	}
};
</script>
<style lang="scss" scoped>
td.ivu-table-expanded-cell {
	padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/report/chain-report/index.vue